import { useEffect, useState } from 'react';
import cn from 'classnames';

import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { IKnmErknmFormViolation } from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';

import { ModalHeader } from '../../../UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from '../../../UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from '../../../UIPackage/ModalModule/components/ModalActions';
import { Button } from '../../../UIPackage/MainModule/components/Button';
import styles from './ErknmViolationsSelectModal.module.scss';

interface IErknmViolationsSelectModalProps {
  violations: IKnmErknmFormViolation[];
  visible: boolean;
  onClose: () => void;
  onSubmit: (items: IKnmErknmFormViolation[]) => void;
}

export const ErknmViolationsSelectModal = ({
  violations,
  visible,
  onClose,
  onSubmit,
}: IErknmViolationsSelectModalProps) => {
  const [selectedViolations, setSelectedViolations] = useState<IKnmErknmFormViolation[]>([]);

  useEffect(() => {
    if (visible) setSelectedViolations([]);
  }, [visible]);

  const isSelected = (violation: IKnmErknmFormViolation): boolean => {
    return !!selectedViolations.find(selectedViolation => selectedViolation.id === violation.id);
  };

  const handleSelect = (violation: IKnmErknmFormViolation) => {
    if (isSelected(violation)) {
      setSelectedViolations(selectedViolations.filter(selectedViolation => selectedViolation.id !== violation.id));
    } else setSelectedViolations([...selectedViolations, violation]);
  };
  const handleSubmit = () => {
    onSubmit(selectedViolations);
    onClose();
  };

  return (
    <Modal visible={visible} onClose={onClose}>
      <ModalHeader title="Выбор нарушений" />
      <ModalBody overflow="scroll">
        <ul className={styles.ViolationList}>
          {violations?.map(violation => {
            return (
              <li
                key={violation.id}
                className={cn(styles.ViolationItem, {
                  [styles.ViolationItemSelected]: isSelected(violation),
                })}
                onClick={() => handleSelect(violation)}
              >
                {violation.title}
              </li>
            );
          })}
        </ul>
        {!violations?.length && <div className={styles.EmptyModalText}>Нет нарушений, доступных к выбору</div>}
      </ModalBody>
      <ModalActions>
        <Button
          text="Добавить"
          color="primary"
          size="medium"
          onClick={handleSubmit}
          disabled={!selectedViolations.length}
        />
        <Button text="Отмена" size="medium" onClick={onClose} />
      </ModalActions>
    </Modal>
  );
};
